import axios from 'axios'
import { DEV_HOST } from './../assets/js/config'

// 请求拦截
axios.interceptors.request.use(function (config) {
  var tk = JSON.parse(localStorage.getItem('TOKEN'));
  if (tk) config.headers['user-token'] = tk;
  config.headers['content-type'] = 'application/json;charset=UTF-8';
  // 微信登录绑定手机号特殊处理【start】
  // 微信登录绑定手机号特殊处理【end】
  config.baseURL = DEV_HOST + '/api/v1/';
  return config;
}, function (err) {
  return Promise.reject((err || {}).data)
})
axios.interceptors.response.use(function (res) {
  if (res.data.code == 200) return res.data;
  if (res.data.code == 1) return res.data;
  if (res.data.code == 0) return res.data;
  if (res.data.code == -201) {
    localStorage.removeItem("userInfo");
    localStorage.removeItem("TOKEN");
    this.$router.push({paht:'/login'})
  }
  return Promise.reject(res.data);
}, function (err) {
  return Promise.reject((err || {}).data)
})

// 导出请求
export function post(url, data) {
  return axios({
    method: 'post',
    url,
    data,
    params: data,
  })
}

export function get(url, data) {
  return axios({
    method: 'get',
    url,
    data,
    params: data,
  })
}


// WEBPACK FOOTER //
// ./src/utils/request.js